import { Box, LinearProgress } from '@mui/material';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

const SuspenseLayout = (): JSX.Element => {
  const renderLinearProgress = () => {
    return (
      <Box
        sx={{
          width: '100%',
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: (theme) => theme.zIndex.appBar + 1,
        }}
      >
        <LinearProgress aria-busy variant="indeterminate" />
      </Box>
    );
  };

  return (
    <Suspense fallback={renderLinearProgress()}>
      <Outlet />
    </Suspense>
  );
};

export default SuspenseLayout;
